
    export default {
      name: "ScheduleCityFromTo",
      props: {
        info_lading: {
          type: Object,
          default: {
            lading_page: [],
            reviews: [],
            price: [],
            schedule: {}
          }
        },
        title: {
          type: String,
          default: '',
        }
      },
      data() {
        return {}
      }
    }
